module.exports = __webpack_public_path__ + "img/8dae8c3.svg";